import { io } from "socket.io-client";

// URL base del backend
const SOCKET_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect() {
    if (!this.socket) {
      this.socket = io(SOCKET_URL, {
        transports: ["polling"],
        reconnectionAttempts: 10,
        reconnectionDelay: 2000,
      });

      this.socket.on("connect", () => {
        console.log("Conectado al servidor WebSockets");
      });

      this.socket.on("disconnect", (reason) => {
        console.warn("Desconectado del servidor WebSockets:", reason);
      });

      this.socket.on("connect_error", (error) => {
        console.error("Error de conexión WebSockets:", error);
      });
    }

    return this.socket;
  }

  on(eventName, callback) {
    if (!this.socket) {
      this.connect();
    }

    this.socket.on(eventName, callback);

    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Set());
    }
    this.listeners.get(eventName).add(callback);
  }

  off(eventName, callback) {
    if (this.socket) {
      this.socket.off(eventName, callback);

      if (this.listeners.has(eventName)) {
        this.listeners.get(eventName).delete(callback);
      }
    }
  }

  emit(eventName, data) {
    if (!this.socket) {
      this.connect();
    }
    this.socket.emit(eventName, data);
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.listeners.clear();
    }
  }
}

const socketServiceInstance = new SocketService();
export default socketServiceInstance;
